import { ApiClient } from '@webapp/core/services/ApiClient'
import { ReimbursementSettingsRepository } from './ReimbursementSettingsRepository'

export const reimbursementSettingsRepository =
  new ReimbursementSettingsRepository({
    httpClient: ApiClient,
  })

export { ReimbursementSettingsRepository }
